import { create } from 'zustand';
import { adminScope } from '@/utility/global_consts';

export type UserToken = {
  roles: string[];
  groups?: string[];
  [key: string]: unknown;
};

// Roles an admin can force via the role toggle. `null` = no override.
// Single source of truth: add a role here and it both type-checks and appears in the toggle.
export const FORCED_ROLES = ['write', 'operator', 'read'] as const;

export type ForcedRole = (typeof FORCED_ROLES)[number];

type UserStore = {
  isAdmin: boolean;
  groups: string[];
  forcedRole: ForcedRole | null;
  setIsAdmin: (token?: UserToken) => void;
  setGroups: (token?: UserToken) => void;
  setForcedRole: (role: ForcedRole | null) => void;
};

export const useUserStore = create<UserStore>((set) => ({
  isAdmin: false,
  groups: [],
  forcedRole: null,
  setIsAdmin: (token?: UserToken) => {
    if (!token) {
      set({ isAdmin: false });
    } else {
      if (token.roles.includes(adminScope)) {
        set({ isAdmin: true });
      } else {
        set({ isAdmin: false });
      }
    }
  },
  setGroups: (token?: UserToken) => {
    set({ groups: token?.groups ?? [] });
  },
  setForcedRole: (role: ForcedRole | null) => {
    set({ forcedRole: role });
  },
}));
